<template>
  <div class="grid-view">
    <div class="main-content">
      <search-item
        config-module="515"
        :show-simple="false"
        :expand-adv="true"
        :custom-search-items="customSearchItems"
        @advSearchItemCallBack="toAdvancedQuery"
        @preProcessSearchItem="toPreProcessSearchItem"
      >
        <template slot="operations">
          <el-button v-permission="['button_VoucherMaintenance_generateVoucher']" no="CreateVoucher" type="primary" plain @click="generateHandler">{{ $t('CargoMsg.Cargo_CreateVoucher') }}</el-button>
          <el-button v-permission="['button_VoucherMaintenance_deleteVoucher']" no="DeleteVoucher" type="primary" plain @click="deleteHandler">{{ $t('CargoMsg.Cargo_DeleteVoucher') }}</el-button>
          <el-button v-permission="['button_VoucherMaintenance_forceDeletion']" no="ForceDelete" type="primary" plain @click="forceDeleteClickHandler">{{ $t('CargoMsg.Cargo_ForceDelete') }}</el-button>
          <el-button v-permission="['button_VoucherMaintenance_auditVoucher']" no="ReviewVoucher" type="primary" plain @click="verifyHandler">{{ $t('CargoMsg.Cargo_ReviewVoucher') }}</el-button>
          <el-button v-if="isJDCLOUD" no="KingdeeCloudApprove" type="primary" plain @click="cloudVerifyHandler">{{ $t('CargoMsg.Cargo_KingdeeCloudApprove') }}</el-button>
          <el-button v-permission="['button_VoucherMaintenance_cancelReview']" no="CancelAudit" type="primary" plain @click="cancelVerifyHandler">{{ $t('CargoMsg.Cargo_CancelAudit') }}</el-button>
          <el-button v-permission="['button_VoucherMaintenance_exportCredentials']" no="ExportVoucher" type="primary" plain @click="exportHandler">{{ $t('CargoMsg.Cargo_ExportVoucher') }}</el-button>
          <el-button v-permission="['button_VoucherMaintenance_redOffsetVoucher']" no="WriteBackVoucher" type="primary" plain @click="reverseHandler">{{ $t('CargoMsg.Cargo_WriteBackVoucher') }}</el-button>
          <el-button v-if="yyTcloud" no="SyncTargetDocumentNo" type="primary" plain @click="SyncTargetDocumentNoHandler">{{ $t('CargoMsg.Cargo_SyncTargetDocumentNo') }}</el-button>
          <el-button v-if="yyTcloud" no="RefreshTcloudToken" type="primary" plain @click="RefreshTcloudTokenHandler">{{ $t('CargoMsg.Cargo_RefreshTcloudToken') }}</el-button>
        </template>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="6000002"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div id="footer-wrapper" class="pagination-wrapper">
        <cargo-pagination
          config-module="6000002"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="searchHandler(true)"
        />
      </div>
    </div>
    <accounting-entry-window
      v-if="accountingEntryWindow.visible"
      ref="accountingEntryWindow"
      :visible="accountingEntryWindow.visible"
      :is-ext="isExt"
      :prefix-data-provider="prefixDataProvider"
      :account-title-data-provider="accountTitleDataProvider"
      :mapping-departments="mappingDepartments"
      :mapping-staffs="mappingStaffs"
      :voucher="accountingEntryWindow.rowData"
      :index="accountingEntryWindow.index"
      :account-set="accountSet"
      :check="activeEditVoucherVerification"
      :check-department="checkDepartmentAccountingItem"
      @close="() => accountingEntryWindow.visible=false"
      @updateTargetDocumentNo="updateTargetDocumentNo"
      @updateAudit="updateAudit"
    />
    <query-window
      v-show="queryWindowDialog.visible"
      ref="queryWindow"
      :visible="queryWindowDialog.visible"
      :is-ext="isExt"
      :account-set="accountSet"
      :pre-bank-slip-states="preBankSlipStates"
      source="VoucherList"
      @batchGenerate="commitHandler('batchGenerate')"
      @commit="commitHandler('commit')"
      @groupCommit="commitHandler('groupCommit')"
      @close="() => queryWindowDialog.visible=false"
    />
    <date-selector
      v-if="dateSelecterDialog.visible"
      ref="dateSelecter"
      :visible="dateSelecterDialog.visible"
      :account-set="accountSet"
      :current-state="dateSelecterDialog.currentState"
      :biz-data-type="dateSelecterDialog.bizDataType"
      :non-group-data="dateSelecterDialog.nonGroupData"
      :show-account-set-select="dateSelecterDialog.showAccountSetSelect"
      :office-id="dateSelecterDialog.officeId"
      :generate-type="generateType"
      @select="selectDataHandler"
      @groupCommit="selectDataHandler"
      @cancel="() => dateSelecterDialog.visible=false"
    />
  </div>
</template>

<script>
import AccountingEntryWindow from './AccountingEntryWindow'
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import {
  query,
  remove,
  verify,
  reverse,
  checkDocumentIsExport,
  checkMapping,
  checkDocumentNotNull,
  exportExcelByJDEAS,
  exportExcelByJDYXK,
  generateVoucher,
  batchGenerateVoucher,
  exportExcelByDIRECTJDEAS,
  exportExcelByJDYXC,
  validateVoucherForExportJDYXK,
  exportYYTCLOUD,
  queryYYTCLOUD,
  checkDocumentByJdJDY,
  exportJdJDY,
  refreshTcloudToken,
  exportExcelByYyu8,
  exportExcelByYYU8V16,
  exportExcelByOj
} from '@/api/financeManage/accountingDocument'
import StrUtils from '@/utils/StrUtils'
import VoucherUtils from '@/utils/VoucherUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import { getGridSelected } from '@/utils/agGrid'
import DateUtils from '@/utils/dateUtils'
import URL from '@/api/urlTranslator'
import QueryWindow from '@/views/cargo/v0/FinanceManage/VoucherMaintenance/QueryWindow'
import DateSelector from '@/views/cargo/v0/FinanceManage/VoucherMaintenance/DateSelector'
import moment from 'moment'
import { checkSpecialCharge } from '@/api/clearing/actualAmount'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { queryAccountTitle } from '@/api/financeManage/entryAccountTitle'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { VOUCHER_EXPORTED } from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'

export default {
  name: 'VoucherList',
  components: { CargoAdvanceSelect, AccountingEntryWindow, cargoUserSelect, QueryWindow, DateSelector, searchItem },
  props: {
    accountSet: { type: Object }, // 账套
    accountSetUuid: { type: String, default: '' }
  },
  data() {
    return {
      isExt: false,
      // prefixDataProvider: [],
      // accountTitleDataProvider: [],
      accountingEntryWindow: {
        visible: false,
        index: -1,
        rowData: []
      },
      selectTypeNames: TYPE_NAMES,
      prefixText: '', // 凭证字
      documentNoTextFrom: undefined, // 凭证号
      documentNoTextTo: undefined,
      dfFrom: moment().subtract(1, 'months').startOf('month').format('yyyy-MM-DD'), // 凭证日期
      dfTo: null,
      auditDateFrom: null,
      auditDateTo: null,
      auditByList: [], // 审核人
      txtState: null, // 凭证状态
      txtProjectNo: '', // 项目编号
      txtTargetDocumentNo: '', // 对方凭证号
      summaryText: '', // 摘要
      accountTitle: '', // 科目
      accountTitleNameList: [], // 科目名称
      entryAccountTitleDataProvider: [],
      currencyText: '', // 币种
      sourceAmountFrom: undefined, // 金额
      sourceAmountTo: undefined,
      createdByAC: 0, // 制单人
      pushState: null, // 推送状态， 0:未推送，1已推送
      errorFlag: null, // 是否报错， 0:否，1:是
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: this.onRowDoubleClicked,
        onSortChanged: this.onSortChanged,
        onCellFocused: event => {
          this.accountingEntryWindow.index = event.rowIndex || -1
        }
      },
      columnDefs: [
        {
          headerName: '', checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('CargoMsg.Cargo_VoucherLetter'), field: 'prefix', width: 80 },
        { headerName: this.$t('CargoMsg.Cargo_VoucherNo'), field: 'documentNo', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_ProofDate'), field: 'documentDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }, width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_PreparedBy'), field: 'documentMaker',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }, width: 100 },
        { headerName: this.$t('CargoMsg.Cargo_AuditDate'), field: 'verifyDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }, width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_Auditor'), field: 'verifier',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }, width: 100 },
        { headerName: this.$t('CargoMsg.Cargo_VoucherStatus'), field: 'state',
          cellRenderer: (params) => {
            return ColumnUtils.voucherStateLabelFunc(params.value)
          }, width: 100 },
        { headerName: this.$t('CargoMsg.Cargo_OppositeVoucherNo'), field: 'targetDocumentNo', width: 150 },
        { headerName: this.$t('CargoMsg.Cargo_DebitAmountCN'), field: 'debitTotal', width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.returnTwoZeroFormatNumber(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_CreditAmountCN'), field: 'creditTotal', width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.returnTwoZeroFormatNumber(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PushMiddleTable'),
          field: 'pushState',
          width: 150,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.pushStateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_IfError'),
          field: 'errorFlag',
          width: 150,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunctionWitNull(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ErrorInfo'),
          field: 'errorInfo',
          width: 150,
          hide: true
        },
        { headerName: this.$t('CargoMsg.Cargo_View'),
          field: 'requestMsg',
          width: 150,
          cellRenderer: params => {
            if (params.value) {
              const link = document.createElement('a')
              link.href = 'javascript:void(0)'
              link.textContent = this.$t('CargoMsg.Cargo_View')
              link.style.color = '#46a6ff'
              link.addEventListener('click', () => {
                this.queryApiReqLogHandler(params.data)
              })
              return link
            }
            return ''
          }
        }
      ],
      rowData: [],
      searchConditions: {
        conditions: [],
        branchId: this.$store.getters.currentOfficeId,
        total: 0,
        pageNum: 1,
        pageSize: 20,
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      selectedItem: {}, // 表格选中项
      selectedKeys: [],
      voucherNo: 0,
      exportVoucherInOrder: false, // CARGO-6658，强制要求按连续凭证号导出凭证（0:不强制 1:默认强制）
      enableCommission: false, // 淳宏定制化功能
      generateVoucherByExtraConditions: false, // CARGO-9395，生成凭证的费用是否根据查询条件（0:默认否, 1:是）
      activeEditVoucherVerification: false, // 是否开启生成凭证保存校验
      checkDepartmentAccountingItem: false, // 校验损益类科目的部门为虚拟部门
      queryWindowDialog: {
        visible: false
      },
      dateSelecterDialog: {
        visible: false,
        currentState: 'normal', // normal/ext
        bizDataType: 0,
        nonGroupData: [],
        showAccountSetSelect: false,
        officeId: this.branchId
      },
      processing: false,
      generateType: 'commit',
      bizType: 0,
      voucherDate: null,
      dateType: null, // 日期类型
      keys: [],
      chargeKeys: null,
      isRedPunch: false,
      extraConditions: [],
      isReceiptPaymentPrefix: false, // 是否实收付凭证字
      isAr: false, // 支付类型
      receiptPaymentType: -1, // 收付方式
      isExport: false,
      bizTypes: [],
      startDate: null,
      endDate: null,
      preBankSlipStates: [ClearingConstants.BANK_SLIP_STATES.code],
      exportInvoiceTitle: false, // CARGO-19044，锦昶：控制导出凭证时客户抓取应收开票抬头的值（0=默认否 1=是）
      invoicePayableAndReceiptPaymentOffsetMergeExport: false, // CARGO-34316，应付发票和预付款冲回凭证合并导出
      repeatByPassExceptionExport: true, // CARGO-44501 控制避免多次已导出确认框
      exportNotRequireAudited: false, // 是否开启凭证导出时无需审核的功能
      customSearchItems: []
    }
  },
  computed: {
    SystemConstants() {
      return SystemConstants
    },
    FinanceInterfaceConstants() {
      return FinanceInterfaceConstants
    },
    // 凭证类型
    prefixDataProvider() {
      if (this.accountSet) {
        // return this.accountSet.accountingDocumentType
        // prefix去重显示
        const prefixList = []
        for (const accountingDocumentType of this.accountSet.accountingDocumentType) {
          if (prefixList.length === 0) {
            prefixList.push(accountingDocumentType)
          } else {
            let bExist = false
            for (const prefixData of prefixList) {
              if (prefixData.prefix === accountingDocumentType.prefix) {
                bExist = true
                break
              }
            }
            if (!bExist) prefixList.push(accountingDocumentType)
          }
        }
        return prefixList
      } else {
        return []
      }
    },
    // 科目
    accountTitleDataProvider() {
      if (this.accountSet) {
        return this.accountSet.accountTitle
      } else {
        return []
      }
    },
    // 部门
    mappingDepartments() {
      if (this.accountSet) {
        return this.accountSet.mappingDepartments
      } else {
        return []
      }
    },
    // 职员
    mappingStaffs() {
      if (this.accountSet) {
        return this.accountSet.mappingStaffs
      } else {
        return []
      }
    },
    isJDCLOUD() {
      if (this.accountSet === null) {
        return false
      } else {
        return this.accountSet.softwareVersions === 'JDCLOUD'
      }
    },
    jdEAS() {
      if (this.accountSet === null) {
        return false
      } else {
        return this.accountSet.softwareVersions === 'JDEAS'
      }
    },
    jdYXK() {
      if (this.accountSet === null) {
        return false
      } else {
        return this.accountSet.softwareVersions === 'JDYXK'
      }
    },
    jdYXC() { // 金蝶云星辰
      if (this.accountSet === null) {
        return false
      } else {
        return this.accountSet.softwareVersions === 'JDYXC'
      }
    },
    yyu8() { // 用友U8
      return this.accountSet ? this.accountSet.softwareVersions === 'YYU8' : false
    },
    yyU8V16() { // 用友U8V16.5
      if (this.accountSet === null) {
        return false
      } else {
        return this.accountSet.softwareVersions === 'YYU8V16'
      }
    },
    // 金蝶精斗云
    jdJDY() {
      if (this.accountSet === null) {
        return false
      } else {
        return this.accountSet.softwareVersions === 'JDJDY'
      }
    },
    directJDEAS() {
      if (this.accountSet === null) {
        return false
      } else {
        return this.accountSet.softwareVersions === 'DIRECTJDEAS'
      }
    },
    isProcessing() {
      return this.processing
    },
    yyTcloud() {
      if (this.accountSet === null) {
        return false
      } else {
        return this.accountSet.softwareVersions === 'YYTCLOUD'
      }
    },
    branchId() {
      if (this.accountSet && RateUtil.useOrderCenterMode()) {
        return this.accountSet.branchId
      } else {
        return this.$store.getters.currentOfficeId
      }
    },
    thirdPartyTable() {
      if (this.accountSet === null) {
        return false
      } else {
        return this.accountSet.softwareVersions === 'THIRDPARTYTABLE'
      }
    }
  },
  watch: {
    async accountSetUuid(newVal, oldVal) {
      if (!newVal) {
        this.entryAccountTitleDataProvider = []
      }
      if (newVal && newVal !== oldVal) {
        await this.queryAccountTitleName()
      }
      this.getCustomSearchItems()
    },
    isExt() {
      this.getCustomSearchItems()
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.initConfig()
    this.getCustomSearchItems()
  },
  methods: {
    // 配置参数
    initConfig() {
      this.isExt = Number(cache.config.get('ext')) === 1
      this.exportVoucherInOrder = Number(cache.config.get('ExportVoucherInOrder')) === 1
      this.generateVoucherByExtraConditions = Number(cache.config.get('generateVoucherByExtraConditions')) === 1
      this.enableCommission = Number(cache.config.get('enableCommission')) === 1
      this.activeEditVoucherVerification = Number(cache.config.get('activeEditVoucherVerification')) === 1
      this.checkDepartmentAccountingItem = Number(cache.config.get('CheckDepartmentAccountingItem')) === 1
      this.exportInvoiceTitle = Number(cache.config.get('exportVoucherCustomerByInvoiceTitle')) === 1
      this.invoicePayableAndReceiptPaymentOffsetMergeExport = Number(cache.config.get('InvoicePayableAndReceiptPaymentOffsetMergeExport')) === 1
      this.exportNotRequireAudited = Number(cache.config.get('VoucherExportDoesNotRequireApproval')) === 1
    },
    getCustomSearchItems() {
      this.customSearchItems = [{
        'action': 2,
        'itemType': 'select',
        'itemCondition': [],
        'defaultConditionVal': '',
        'fieldType': 'FIELD_DROP_DOWN_LIST',
        'itemName': 'accountingDocument.PREFIX',
        'itemLabel': 'CargoMsg.Cargo_VoucherLetter',
        'itemValue': '',
        'defaultSelected': 1,
        'selected': 0,
        'dropdownDataRef': '',
        'dataCacheKey': '',
        'valueExpression': {
          valueType: 'static',
          valueContent: this.prefixDataProvider.map(item => ({ code: item.prefix, chineseName: item.prefix, englishName: item.prefix }))
        },
        'lock': false,
        'defaultValue': ''
      }, {
        'action': 2,
        'itemType': 'date',
        'fieldType': 'FIELD_DATE_RANGE',
        'itemCondition': [],
        'subType': 'range',
        'dateItemExtend': 1,
        'defaultConditionVal': '',
        'itemName': 'accountingDocument.DOCUMENT_DATE',
        'itemLabel': 'CargoMsg.Cargo_ProofDate',
        'itemValue': [],
        'defaultSelected': 1,
        'selected': 0,
        'valueExpression': '',
        'lock': false,
        'defaultValue': ''
      }, {
        'action': 2,
        'itemType': 'select',
        'multiple': 1,
        'itemCondition': [{
          'code': 'IN',
          'chineseName': '包含',
          'englishName': 'In',
          'children': null,
          'selected': false
        }],
        'defaultConditionVal': 'IN',
        'fieldType': 'FIELD_DROP_DOWN_LIST',
        'itemName': 'accountingDocument.STATE',
        'itemLabel': 'CargoMsg.Cargo_VoucherStatus',
        'itemValue': '',
        'defaultSelected': 1,
        'selected': 0,
        'dropdownDataRef': '',
        'dataCacheKey': '',
        'valueExpression': {
          valueType: 'static',
          valueContent: [...FinanceInterfaceConstants.VOUCHER_STATES2]
        },
        'lock': false,
        'defaultValue': ''
      }]
      if (this.isExt) {
        this.customSearchItems.push({
          'action': 2,
          'itemType': 'input',
          'subType': '',
          'fieldType': 'FIELD_TEXT',
          'itemCondition': [],
          'defaultConditionVal': '',
          'itemName': 'accountingEntry.SUMMARY',
          'itemLabel': 'CargoMsg.Cargo_Abstract',
          'itemValue': '',
          'defaultSelected': 1,
          'selected': 0,
          'valueExpression': '',
          'lock': false,
          'defaultValue': ''
        }, {
          'action': 2,
          'itemType': 'advanceSelect2',
          'fieldType': 'FIELD_DROP_DOWN_LIST',
          'multiple': 0,
          'itemCondition': [],
          'defaultConditionVal': '',
          'itemName': 'accountingEntry.ACCOUNT_TITLE',
          'itemLabel': 'CargoMsg.Cargo_AccountTitle2',
          'itemValue': '',
          'defaultSelected': 1,
          'selected': 0,
          'dropdownDataRef': '',
          'dataCacheKey': 'static_data_AccountTitle',
          'valueExpression': {
            valueType: 'static',
            valueContent: this.accountTitleDataProvider
          },
          'lock': false,
          'defaultValue': ''
        }, {
          'action': 2,
          'itemType': 'input',
          'subType': '',
          'fieldType': 'FIELD_TEXT',
          'itemCondition': [],
          'defaultConditionVal': '',
          'itemName': 'accountingEntry.SOURCE_CURRENCY',
          'itemLabel': 'CargoMsg.Cargo_Currency',
          'itemValue': '',
          'defaultSelected': 1,
          'selected': 0,
          'valueExpression': '',
          'lock': false,
          'defaultValue': ''
        }, {
          'action': 2,
          'itemType': 'input',
          'subType': 'bigdecimalrangeWithPrecision',
          'fieldType': 'FIELD_POSITIVE_NUMBER_RANGE',
          'itemCondition': [],
          'defaultConditionVal': '',
          'itemName': 'accountingEntry.SOURCE_AMOUNT',
          'itemLabel': 'CargoMsg.Cargo_Amount',
          'itemValue': '',
          'defaultSelected': 1,
          'selected': 0,
          'valueExpression': '',
          'lock': false,
          'defaultValue': ''
        }, {
          'action': 2,
          'itemType': '',
          'fieldType': 'FIELD_DROP_DOWN_LIST',
          'multiple': 0,
          'itemCondition': [],
          'defaultConditionVal': '',
          'itemName': 'accountingDocument.CREATED_BY',
          'itemLabel': 'CargoMsg.Cargo_PreparedBy',
          'itemValue': '',
          'defaultSelected': 1,
          'selected': 0,
          'dropdownDataRef': 'basic_data_User',
          'dataCacheKey': 'basic_data_User',
          'valueExpression': '',
          'lock': false,
          'defaultValue': ''
        })
      } else {
        this.customSearchItems.push({
          'action': 1,
          'itemType': 'input',
          'fieldType': 'FIELD_TEXT',
          'itemName': 'accountingEntry.SUMMARY'
        }, {
          'action': 1,
          'itemType': 'advanceSelect2',
          'fieldType': 'FIELD_DROP_DOWN_LIST',
          'itemName': 'accountingEntry.ACCOUNT_TITLE'
        }, {
          'action': 1,
          'itemType': 'input',
          'fieldType': 'FIELD_TEXT',
          'itemName': 'accountingEntry.SOURCE_CURRENCY'
        }, {
          'action': 1,
          'itemType': 'input',
          'fieldType': 'FIELD_POSITIVE_NUMBER_RANGE',
          'itemName': 'accountingEntry.SOURCE_AMOUNT'
        }, {
          'action': 1,
          'itemType': '',
          'fieldType': 'FIELD_DROP_DOWN_LIST',
          'itemName': 'accountingDocument.CREATED_BY'
        })
      }
      this.customSearchItems.push({
        'action': 2,
        'itemType': 'advanceSelect2',
        'fieldType': 'FIELD_DROP_DOWN_LIST',
        'multiple': 0,
        'itemCondition': [],
        'defaultConditionVal': '',
        'itemName': 'accountingEntry.ACCOUNT_TITLE_NAME',
        'itemLabel': 'CargoMsg.Cargo_AccountTitle',
        'itemValue': '',
        'defaultSelected': 1,
        'selected': 0,
        'dropdownDataRef': '',
        'dataCacheKey': 'static_data_AccountTitle',
        'valueExpression': {
          valueType: 'static',
          valueContent: this.entryAccountTitleDataProvider
        },
        'filterTagNames': ['name'],
        'tagValue': 'name',
        'tagName': 'name',
        'lock': false,
        'defaultValue': ''
      }, {
        'action': 2,
        'itemType': 'select',
        'itemCondition': [],
        'defaultConditionVal': '',
        'fieldType': 'FIELD_DROP_DOWN_LIST',
        'itemName': 'accountingDocument.PUSH_STATE',
        'itemLabel': 'CargoMsg.Cargo_PushMiddleTable',
        'itemValue': '',
        'defaultSelected': 1,
        'selected': 0,
        'dropdownDataRef': '',
        'dataCacheKey': '',
        'valueExpression': {
          valueType: 'static',
          valueContent: [...FinanceInterfaceConstants.PUSH_STATES]
        },
        'lock': false,
        'defaultValue': ''
      }, {
        'action': 2,
        'itemType': 'select',
        'itemCondition': [],
        'defaultConditionVal': '',
        'fieldType': 'FIELD_DROP_DOWN_LIST',
        'itemName': 'errorFlag',
        'itemLabel': 'CargoMsg.Cargo_IfError',
        'itemValue': '',
        'defaultSelected': 1,
        'selected': 0,
        'dropdownDataRef': '',
        'dataCacheKey': '',
        'valueExpression': {
          valueType: 'static',
          valueContent: [...SystemConstants.YESORNO_STATES]
        },
        'lock': false,
        'defaultValue': ''
      })
    },
    // 高级查询
    async toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        const option = AdvancedSearchOption.removeOption('accountingDocument.STATE', data)
        if (option) {
          if (option.value instanceof Array && !option.value.includes(null)) {
            data.push(option)
          }
        }
        this.searchConditions.conditions = data
      }
      this.searchConditions.branchId = this.$store.getters.currentOfficeId
      this.searchHandler(false)
    },
    // 查询
    searchHandler(pagination = false) {
      this.initConfig()
      if (this.$refs.queryWindow) this.$refs.queryWindow.reInitConfig()
      // const condition = {}
      // if (!StrUtils.isEmpty(this.prefixText)) condition.prefix = this.prefixText
      // if (!isNaN(this.documentNoTextFrom)) condition.documentNoFrom = this.documentNoTextFrom
      // if (!isNaN(this.documentNoTextTo)) condition.documentNoTo = this.documentNoTextTo
      // if (this.dfFrom) condition.startDate = this.dfFrom + ' 00:00:00'
      // if (this.dfTo) condition.endDate = this.dfTo + ' 00:00:00'
      // if (this.txtState !== null) condition.state = this.txtState
      // if (!StrUtils.isEmpty(this.txtProjectNo)) condition.projectNumber = this.txtProjectNo
      // if (!StrUtils.isEmpty(this.txtTargetDocumentNo)) condition.targetDocumentNo = this.txtTargetDocumentNo
      // if (this.auditDateFrom) condition.auditDateFrom = this.auditDateFrom + ' 00:00:00'
      // if (this.auditDateTo) condition.auditDateTo = this.auditDateTo + ' 00:00:00'
      // if (this.auditByList && this.auditByList.length > 0) {
      //   let verifier = ''
      //   for (const p of this.auditByList) {
      //     if (verifier) {
      //       verifier += ','
      //     }
      //     verifier += p
      //   }
      //   if (verifier) condition.verifier = verifier
      // }
      // if (this.accountTitleNameList && this.accountTitleNameList.length > 0) {
      //   let accountTitleName = ''
      //   for (const p of this.accountTitleNameList) {
      //     if (accountTitleName) {
      //       accountTitleName += ','
      //     }
      //     accountTitleName += '\''
      //     accountTitleName += p
      //     accountTitleName += '\''
      //   }
      //   if (accountTitleName) condition.accountTitleName = accountTitleName
      // }
      // if (this.isExt) {
      //   if (!StrUtils.isEmpty(this.summaryText)) condition.summary = this.summaryText
      //   if (!StrUtils.isEmpty(this.accountTitle)) condition.accountTitle = this.accountTitle
      //   if (!StrUtils.isEmpty(this.currencyText)) condition.sourceCurrency = this.currencyText
      //   if (!isNaN(this.sourceAmountFrom)) condition.sourceAmountFrom = this.sourceAmountFrom
      //   if (!isNaN(this.sourceAmountTo)) condition.sourceAmountTo = this.sourceAmountTo
      //   if (this.createdByAC) condition.createdBy = this.createdByAC
      // }
      // // 查询条件
      // if (this.pushState !== null){
      //   condition.pushState = this.pushState
      // }
      // if (this.errorFlag !== null){
      //   condition.errorFlag = this.errorFlag
      // }
      if (!pagination) this.searchConditions.pageNum = 1
      const requestBody = { accountingSetKey: this.accountSet.uuid, conditions: this.searchConditions.conditions, branchId: this.searchConditions.branchId, pageNum: this.searchConditions.pageNum, pageSize: this.searchConditions.pageSize }
      console.log('requestBody', requestBody)
      this.loading = getLoading()
      query(requestBody).then(res => {
        this.rowData = res.data.list
        this.searchConditions.total = Number(res.data.total)
        this.selectedItem = {}
        this.accountingEntryWindow.index = -1
        this.gridOptions.api.clearFocusedCell()
        this.accountingEntryWindow.rowData = this.rowData
      }).finally(() => {
        this.loading.close()
      })
    },
    // 生成凭证
    generateHandler() {
      if (this.accountSet && !VoucherUtils.checkAccountSetBranch(this.accountSet.branchId, this.$store.getters.currentOfficeId)) {
        this.$confirm(this.$t('CargoMsg.Cargo_CheckAccountSetBranchId'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          dangerouslyUseHTMLString: true,
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          this.queryWindowDialog.visible = true
          this.$refs.queryWindow.resetRowData()
        }).catch(() => {})
      } else {
        this.queryWindowDialog.visible = true
        this.$refs.queryWindow.resetRowData()
      }
    },
    commitHandler(type) {
      if (this.isProcessing) return

      this.isReceiptPaymentPrefix = false
      this.isAr = false
      this.receiptPaymentType = -1
      this.generateType = type
      this.bizType = this.$refs.queryWindow.bizDataType()
      this.keys = this.$refs.queryWindow.selectedKeys()
      this.chargeKeys = this.$refs.queryWindow.selectedChargeKeys()
      this.isRedPunch = this.$refs.queryWindow.isRedPunch()
      this.extraConditions = this.$refs.queryWindow.extraConditions()
      this.isExport = this.$refs.queryWindow.isExport()
      this.bizTypes = this.$refs.queryWindow.bizTypes()
      this.startDate = this.$refs.queryWindow.startDate()
      this.endDate = this.$refs.queryWindow.endDate()

      if (this.generateType === 'commit') {
        this.dateSelecterDialog.currentState = 'normal'
        this.dateSelecterDialog.bizDataType = this.bizType
        this.dateSelecterDialog.nonGroupData = this.$refs.queryWindow.getSelections()
      } else if (this.generateType === 'groupCommit') {
        this.dateSelecterDialog.currentState = 'ext'
        this.dateSelecterDialog.bizDataType = this.bizType
        this.dateSelecterDialog.nonGroupData = this.$refs.queryWindow.selectedItems()
        //
        this.isReceiptPaymentPrefix = this.$refs.queryWindow.isReceiptPaymentPrefix
        this.isAr = this.$refs.queryWindow.isAr
        this.receiptPaymentType = this.$refs.queryWindow.receiptPaymentType
      }
      this.dateSelecterDialog.officeId = this.branchId

      this.dateSelecterDialog.visible = true
    },
    selectDataHandler() {
      this.voucherDate = this.$refs.dateSelecter.selectedDate()
      this.dateType = this.$refs.dateSelecter.selectedDateType() // 日期类型
      this.dateSelecterDialog.visible = false

      if (this.generateType === 'commit') {
        // 淳宏定制化功能
        if (this.enableCommission && this.bizType === 13) {
          // ActualAmount.checkSpecialCharge
          this.loading = getLoading()
          checkSpecialCharge(this.keys).then(res => {
            console.log('checkSpecialCharge', res)
            this.checkSuccessFunc(res.data)
          }).finally(() => {
            this.loading.close()
          })
        } else {
          if (this.generateVoucherByExtraConditions) {
            // AccountingDocument.generateVoucherByExtraConditions
            const requestBody = { 'accountSetKey': this.accountSet.uuid, 'bizType': this.bizType, 'voucherDate': this.voucherDate, 'keys': this.keys, 'chargeKeys': this.chargeKeys, 'isGroupGen': false, 'autoVerify': false, 'isRedPunch': this.isRedPunch, 'branchId': this.branchId, 'conditions': this.extraConditions }
            this.toGenerateVoucher(requestBody)
          } else {
            const requestBody = { 'accountSetKey': this.accountSet.uuid, 'bizType': this.bizType, 'voucherDate': this.voucherDate, 'keys': this.keys, 'chargeKeys': this.chargeKeys, 'isGroupGen': false, 'autoVerify': false, 'isRedPunch': this.isRedPunch, 'branchId': this.branchId }
            this.toGenerateVoucher(requestBody)
          }
        }
      } else if (this.generateType === 'groupCommit') {
        // 淳宏定制化功能
        if (this.enableCommission && this.bizType === 13) {
          // ActualAmount.checkSpecialCharge
          this.loading = getLoading()
          checkSpecialCharge(this.keys).then(res => {
            console.log('checkSpecialCharge', res)
            this.checkSuccess2Func(res.data)
          }).finally(() => {
            this.loading.close()
          })
        } else {
          // CARGO-1774，合并生成凭证后凭证字为记
          if (this.isReceiptPaymentPrefix) {
            // AccountingDocument.generateVoucher2ReceiptPaymentPrefix
            const requestBody = { 'accountSetKey': this.accountSet.uuid, 'bizType': this.bizType, 'voucherDate': this.voucherDate, 'keys': this.keys, 'chargeKeys': this.chargeKeys, 'isGroupGen': true, 'autoVerify': false, 'isRedPunch': this.isRedPunch, 'branchId': this.branchId, 'isReceiptPaymentPrefix': this.isReceiptPaymentPrefix, 'isAr': this.isAr, 'receiptPaymentType': this.receiptPaymentType }
            this.toGenerateVoucher(requestBody)
          } else {
            if (this.generateVoucherByExtraConditions) {
              // AccountingDocument.generateVoucherByExtraConditions
              const requestBody = { 'accountSetKey': this.accountSet.uuid, 'bizType': this.bizType, 'voucherDate': this.voucherDate, 'keys': this.keys, 'chargeKeys': this.chargeKeys, 'isGroupGen': true, 'autoVerify': false, 'isRedPunch': this.isRedPunch, 'branchId': this.branchId, 'conditions': this.extraConditions }
              this.toGenerateVoucher(requestBody)
            } else {
              const requestBody = { 'accountSetKey': this.accountSet.uuid, 'bizType': this.bizType, 'voucherDate': this.voucherDate, 'keys': this.keys, 'chargeKeys': this.chargeKeys, 'isGroupGen': true, 'autoVerify': false, 'isRedPunch': this.isRedPunch, 'branchId': this.branchId }
              this.toGenerateVoucher(requestBody)
            }
          }
        }
      } else {
        // AccountingDocument.batchGenerateVoucher
        const requestBody = { 'accountSetKey': this.accountSet.uuid, 'bizTypes': this.bizTypes, 'startDate': this.startDate, 'endDate': this.endDate, 'voucherDate': this.voucherDate, 'autoVerify': this.isExport, 'branchId': this.branchId }
        this.toBatchGenerateVoucher(requestBody)
      }
    },
    checkSuccessFunc(result) {
      if (result) {
        this.$message.warning(this.$t('Message.checkSpecialChargeTips'))
        return
      } else {
        const requestBody = { 'accountSetKey': this.accountSet.uuid, 'bizType': this.bizType, 'voucherDate': this.voucherDate, 'keys': this.keys, 'isGroupGen': false, 'autoVerify': false, 'isRedPunch': this.isRedPunch, 'branchId': this.branchId }
        this.toGenerateVoucher(requestBody)
      }
    },
    checkSuccess2Func(result) {
      if (result) {
        this.$message.warning(this.$t('Message.checkSpecialChargeTips'))
        return
      } else {
        // CARGO-1774，合并生成凭证后凭证字为记
        if (this.isReceiptPaymentPrefix) {
          const requestBody = { 'accountSetKey': this.accountSet.uuid, 'bizType': this.bizType, 'voucherDate': this.voucherDate, 'keys': this.keys, 'isGroupGen': true, 'autoVerify': false, 'isRedPunch': this.isRedPunch, 'branchId': this.branchId, 'isReceiptPaymentPrefix': this.isReceiptPaymentPrefix, 'isAr': this.isAr, 'receiptPaymentType': this.receiptPaymentType }
          this.toGenerateVoucher(requestBody)
        } else {
          const requestBody = { 'accountSetKey': this.accountSet.uuid, 'bizType': this.bizType, 'voucherDate': this.voucherDate, 'keys': this.keys, 'isGroupGen': true, 'autoVerify': false, 'isRedPunch': this.isRedPunch, 'branchId': this.branchId }
          this.toGenerateVoucher(requestBody)
        }
      }
    },
    toGenerateVoucher(requestBody) {
      requestBody.dateType = this.dateType // 日期类型
      console.log('generateHandler', requestBody)
      if (this.isProcessing) return
      this.processing = true
      this.loading = getLoading()
      generateVoucher(requestBody).then(res => {
        console.log('generateVoucher', res.data)
        const documents = res.data
        this.generateResultHandler(documents)
      }).catch(err => {
        console.log('generateVoucher error', err)
      }).finally(() => {
        this.processing = false
        this.loading.close()
      })
    },
    generateResultHandler(documents) {
      const count = documents === null ? 0 : documents.length
      let documentName = ''
      for (const doc of documents) {
        documentName += (StrUtils.isEmpty(documentName) ? '' : ',') + doc.prefix + '-' + doc.documentNo
      }
      const messages = []
      const h = this.$createElement
      messages.push(h('p', null, this.$t('CargoMsg.Cargo_VoucherCreatedSuccessfully').format(count)))
      messages.push(h('p', null, documentName))
      this.$confirm(this.$t('CargoMsg.Cargo_Success'), {
        title: this.$t('CargoMsg.Cargo_Success'),
        message: h('div', null, messages),
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        showCancelButton: false,
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'success'
      }).then(() => {
        if (this.generateType === 'batchGenerate' && count > 0 && this.isExport) {
          // AccountingDocument.checkMapping
          this.selectedKeys = []
          for (const document of documents) {
            this.selectedKeys.push(document.uuid)
          }
          this.executeExport(this.selectedKeys)
        }
        this.queryWindowDialog.visible = false
        this.searchHandler()
      }).catch(() => {
        //
      })
    },
    toBatchGenerateVoucher(requestBody) {
      console.log('batchGenerateHandler', requestBody)
      if (this.isProcessing) return
      this.processing = true
      this.loading = getLoading()
      batchGenerateVoucher(requestBody).then(res => {
        console.log('batchGenerateVoucher', res.data)
        const documents = res.data
        this.generateResultHandler(documents)
      }).catch(err => {
        console.log('batchGenerateVoucher error', err)
      }).finally(() => {
        this.processing = false
        this.loading.close()
      })
    },
    // 删除凭证
    deleteHandler() {
      console.log('deleteHandler')
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) return
      const accountingKeys = []
      for (const accountingDocument of selections) {
        // CARGO-45570 CargoWare生成凭证写入欧坚数据库     删除/强制删除凭证时，查询欧坚中间表，凭证“bInserted”是否导入成功状态。如果已导入用友不可删除。
        if (accountingDocument.state === VOUCHER_EXPORTED.code && this.thirdPartyTable) {
          this.$message.warning(this.$t('CargoMsg.Cargo_StateDeleteError'))
          return
        }
        if (accountingDocument.closing) {
          this.$message.warning(this.$t('CargoMsg.Cargo_VOPLCOCTBD'))
          return
        }
        if (VoucherUtils.checkVoucherDateClosing(accountingDocument.year, accountingDocument.month, this.accountSet.fiscalPeriod)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_VOCMEICSR'))
          return
        }
        if (accountingDocument.state !== FinanceInterfaceConstants.VOUCHER_UNAUDITED.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_OnlyReviewedVouchersCanBeDeleted'))
          return
        }
        if (!StrUtils.isEmpty(accountingDocument.offsetDocumentUuid) || [3, 4].includes(accountingDocument.state)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_WBOWBVCTBD'))
          return
        }
        accountingKeys.push(accountingDocument.uuid)
      }
      this.$confirm(this.$t('CargoMsg.Cargo_STDTSVRJEWBDTM').format(selections.length), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        this.removeVoucher(accountingKeys)
      }).catch(() => {
        //
      })
    },
    removeVoucher(accountingKeys) {
      if (accountingKeys.length === 0) return
      const requestBody = { accountingSetKey: this.accountSet.uuid, accountingKeys }
      console.log('requestBody', requestBody)
      this.loading = getLoading()
      remove(requestBody).then(res => {
        this.searchHandler()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 强制删除
    forceDeleteClickHandler() {
      console.log('forceDeleteClickHandler')
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) return
      const accountingKeys = []
      for (const accountingDocument of selections) {
        if (accountingDocument.closing) {
          this.$message.warning(this.$t('CargoMsg.Cargo_VOPLCOCTBD'))
          return
        }
        if (VoucherUtils.checkVoucherDateClosing(accountingDocument.year, accountingDocument.month, this.accountSet.fiscalPeriod)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_VOCMEICSR'))
          return
        }
        if (accountingDocument.offsetDocumentUuid) {
          this.$message.warning(this.$t('CargoMsg.Cargo_WBOWBVCTBD'))
          return
        }
        accountingKeys.push(accountingDocument.uuid)
      }
      this.$confirm(this.$t('CargoMsg.Cargo_STDTSVRJEWBDTM').format(selections.length), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        this.removeVoucher(accountingKeys)
      }).catch(() => {
        //
      })
    },
    // 审核凭证
    verifyHandler() {
      console.log('verifyHandler')
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectVoucherToReview'))
        return
      }
      const accountingKeys = []
      for (const accountingDocument of selections) {
        if (VoucherUtils.checkVoucherDateClosing(accountingDocument.year, accountingDocument.month, this.accountSet.fiscalPeriod)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_VOCMEICSR'))
          return
        }
        if (accountingDocument.state !== FinanceInterfaceConstants.VOUCHER_UNAUDITED.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_OVWUSCBE'))
          return
        }
        accountingKeys.push(accountingDocument.uuid)
      }
      if (accountingKeys.length === 0) return
      this.$confirm(this.$t('CargoMsg.Cargo_SureToReviewTheVoucher').format(selections.length), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        this.verify(accountingKeys, FinanceInterfaceConstants.VOUCHER_AUDITED.code)
      }).catch(() => {})
    },
    verify(accountingKeys, state) {
      if (accountingKeys.length === 0) return
      const requestBody = { accountingKeys, state }
      console.log('requestBody', requestBody)
      this.loading = getLoading()
      verify(requestBody).then(res => {
        if (state === FinanceInterfaceConstants.VOUCHER_AUDITED.code) {
          this.$message.success(this.$t('CargoMsg.Cargo_AuditSuccessfully'))
        } else {
          this.$message.success(this.$t('CargoMsg.Cargo_ReviewCancelledSuccessfully'))
        }
        this.searchHandler()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 金蝶Cloud审核
    cloudVerifyHandler() {
      this.$confirm(this.$t('CargoMsg.Cargo_URVUTSWBRIKC'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
        cancelButtonText: this.$t('CargoMsg.Cargo_No'),
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        //
      }).catch(() => {})
    },
    // 取消审核
    cancelVerifyHandler() {
      console.log('cancelVerifyHandler')
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectVoucherToCancel'))
        return
      }
      const accountingKeys = []
      for (const accountingDocument of selections) {
        // CARGO-45570 欧坚租户处理 thirdPartyTable类型 且 pushState等于1后不允许再次导出凭证 和取消审核
        if (this.thirdPartyTable && accountingDocument.pushState === 1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ThirdTableCheck'))
          return
        }

        if (VoucherUtils.checkVoucherDateClosing(accountingDocument.year, accountingDocument.month, this.accountSet.fiscalPeriod)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_VOCMEICSR'))
          return
        }
        if (accountingDocument.state !== FinanceInterfaceConstants.VOUCHER_AUDITED.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_OPVWES'))
          return
        }
        accountingKeys.push(accountingDocument.uuid)
      }
      if (accountingKeys.length === 0) return
      this.$confirm(this.$t('CargoMsg.Cargo_SureToCancelReviewOfTheVoucher').format(selections.length), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        this.verify(accountingKeys, FinanceInterfaceConstants.VOUCHER_UNAUDITED.code)
      }).catch(() => {})
    },
    // 导出凭证
    async exportHandler(recursiveArray) {
      let selections = []
      if (recursiveArray && recursiveArray.length > 0) {
        selections = recursiveArray
      } else {
        selections = getGridSelected(this.gridOptions)
      }
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseData'))
        return
      }
      let flag = false
      let noStr = '：'
      for (const item of selections) {
        if (item.state === FinanceInterfaceConstants.VOUCHER_EXPORTED.code) {
          flag = true
          noStr = noStr + '【' + item.documentNo + '】,'
        }
      }
      // 若存在已导出的凭证，需要确认框提示
      if (flag && this.repeatByPassExceptionExport) {
        let exec = false
        noStr = noStr.substring(0, noStr.length - 1)
        await this.$confirm(this.$t('CargoMsg.Cargo_ThereAreAlreadyExportedVouchers') + noStr, this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(async res => {
          exec = true
        })
        if (!exec) {
          return
        }
      }
      if (this.jdYXK && this.invoicePayableAndReceiptPaymentOffsetMergeExport) {
        const invoicePayable = []
        const otherType = []
        for (const doc of selections) {
          if (doc.businessDataType === FinanceInterfaceConstants.INVOICE_PAYABLE.code ||
            doc.businessDataType === FinanceInterfaceConstants.RECEIPT_PAYMENT_OFFSET.code) {
            invoicePayable.push(doc)
          } else {
            otherType.push(doc)
          }
        }
        if (invoicePayable.length > 0 && otherType.length > 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CheckMergeExport'))
          return
        }
      }
      this.selectedKeys = []
      this.voucherNo = 0
      let selectedArray = []
      const dic = new Map()
      for (const doc of selections) {
        // CARGO-45570 欧坚租户处理 thirdPartyTable类型 且 pushState等于1后不允许再次导出凭证 和取消审核
        if (this.thirdPartyTable && doc.pushState === 1) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ThirdTableCheck'))
          return
        }

        if (VoucherUtils.checkVoucherDateClosing(doc.year, doc.month, this.accountSet.fiscalPeriod)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_VOCMEICSR'))
          return
        }
        if (!this.exportNotRequireAudited && doc.state < FinanceInterfaceConstants.VOUCHER_AUDITED.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ORVCBE'))
          return
        }
        // CARGO-35386 用友U8 V16导出凭证时增加校验
        if (this.yyU8V16 && doc.state === FinanceInterfaceConstants.VOUCHER_EXPORTED.code) {
          continue
        }
        this.selectedKeys.push(doc.uuid)

        const dicKey = doc.prefix + doc.year + doc.month
        if (!dic.has(dicKey)) {
          selectedArray = []
          dic.set(dicKey, selectedArray)
        } else {
          selectedArray = dic.get(dicKey)
        }
        selectedArray.push(doc)
        this.voucherNo = doc.documentNo
      }
      if (this.selectedKeys.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseData'))
        return
      }

      // CARGO-1112，开启EXT参数后不能跳号导出凭证，必须要导出上一个凭证才可以导下一张凭证
      if (this.jdEAS && this.selectedKeys.length > 100) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectedVoucherCantOver100').format(this.selectedKeys.length))
        return
      }

      // CARGO-27405 金蝶云星辰接口：获取凭证号后写入系统
      if (this.jdYXC && this.selectedKeys.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OnlySelectedOneVoucher'))
        return
      }

      // CARGO-46588 校验凭证跳号参数逻辑调整
      if (this.isExt && !this.jdEAS && !this.jdYXC && !this.yyu8 && !this.thirdPartyTable) {
        if (this.exportVoucherInOrder) {
          const checkCollection = []
          for (const key of dic.keys()) {
            selectedArray = dic.get(key)
            const minAd = this.getMinDocumentNo(selectedArray)
            if (minAd) {
              minAd.accountingEntry = null
              checkCollection.push(minAd)
            }
            if (selectedArray.length > 1) {
              if (!this.isSequence(selectedArray)) return
            }
          }
          if (checkCollection.length === 0) return
          this.loading = getLoading()
          checkDocumentIsExport(checkCollection).then(res => {
            if (res.data && res.data.result) {
              this.executeExport(this.selectedKeys)
            } else if (res.data && !res.data.result) {
              this.$message.error(res.data.message)
            }
          }).finally(() => {
            this.loading.close()
          })
        } else {
          this.executeExport(this.selectedKeys)
        }
      } else {
        this.executeExport(this.selectedKeys)
      }
    },
    getMinDocumentNo(accountingDocuments) {
      let docNo = 0
      let result = null
      for (const ad of accountingDocuments) {
        const adNo = ad.documentNo
        if (!docNo) {
          docNo = adNo
          result = ad
        } else {
          if (adNo < docNo) result = ad
        }
      }
      return result
    },
    isSequence(selectedArray) {
      const end = selectedArray[selectedArray.length - 1]
      const start = selectedArray[0]
      if (Math.abs(end.documentNo - start.documentNo) + 1 > selectedArray.length) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OVWCSNCBE'))
        return false
      }
      return true
    },
    executeExport(accountingKeys) {
      if (accountingKeys.length === 0) return
      const requestBody = { accountingSetKey: this.accountSet.uuid, accountingKeys }
      console.log('requestBody', requestBody)
      this.loading = getLoading()
      checkMapping(requestBody).then(res => {
        if (res.data.status === 'SUCCESS') {
          // 亚东 金蝶EAS
          if (this.jdEAS) {
            // 亚东金蝶验证必填项
            this.toCheckDocumentNotNull(this.selectedKeys)
          } else if (this.jdJDY) {
            // 验证导出凭证至金蝶精斗云必填项
            this.toCheckDocumentByJdJDY(this.selectedKeys)
          } else {
            const message = this.yyTcloud ? this.$t('CargoMsg.Cargo_VerifiedSuccessfullyClickToExport') : this.$t('CargoMsg.Cargo_VerifiedSuccessfullyClickToSave')
            this.$confirm(message, this.$t('CargoMsg.Cargo_Tips'), {
              confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
              showCancelButton: false,
              showClose: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              type: 'success'
            }).then(() => {
              this.doExport()
            }).catch(() => {})
          }
        } else {
          this.showMappingError(res.data.details)
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 显示没有Mapping的错误
    showMappingError(details) {
      let s = ''
      if (details.hasOwnProperty('ACCOUNTTITLE')) {
        // CARGO-8459，凭证导出时，增加判断分录科目不为空提示
        const accountTitles = details['ACCOUNTTITLE']
        let warns = ''
        const errorProof = []
        for (const accountTitle of accountTitles) {
          if (accountTitle.indexOf(this.$t('CargoMsg.Cargo_VoucherNo')) !== -1) {
            const voucherTypeMatch = accountTitle.match(/凭证字为‘(.*?)’/)
            const voucherNumberMatch = accountTitle.match(/凭证号是‘(\d+)’/)
            if (voucherTypeMatch && voucherNumberMatch) {
              errorProof.push({ prefix: String(voucherTypeMatch[1]), documentNo: Number(voucherNumberMatch[1]) })
            }
            if (warns === '') {
              warns = accountTitle
            } else {
              warns += '<br>' + accountTitle
            }
          }
        }
        if (this.accountSet.passExceptionExport) {
          this.$confirm(warns, this.$t('Message.Warning'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_SkipAll'), // 全部跳过的按钮
            cancelButtonText: this.$t('CargoMsg.Cargo_Confirm'), // 添加一个取消按钮的文本
            showCancelButton: true, // 显示取消按钮
            showClose: true,
            closeOnClickModal: false,
            closeOnPressEscape: true,
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then(() => {
            // 去掉根据选择的数据，将有问题的凭证去除后重新再导出，如果去掉后为空就直接停止
            const selections = getGridSelected(this.gridOptions)

            // 遍历 selections 数组
            const finalSelections = selections.filter(item => {
              // 使用 some 方法检查是否有匹配的 errorProof 项
              return !errorProof.some(errorItem => {
                return item.prefix === errorItem.prefix && item.documentNo === errorItem.documentNo
              })
            })
            // 如果去掉有问题的凭证后 finalSelections 数组为空，则停止执行后续的导出操作
            this.repeatByPassExceptionExport = false
            this.exportHandler(finalSelections)
          }).catch(() => {})
          return
        } else {
          this.$confirm(warns, this.$t('Message.Warning'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            showCancelButton: false,
            showClose: true,
            closeOnClickModal: false,
            closeOnPressEscape: true,
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then(() => {
            return
          }).catch(() => {})
          return
        }
      }
      if (details.hasOwnProperty('CUSTOMER')) {
        const customers = details['CUSTOMER']
        s += this.$t('CargoMsg.Cargo_CustomerP') + '<br>'
        let customer = ''
        for (const customerId of customers) {
          customer = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', customerId, 'chineseName')
          if (!StrUtils.isEmpty(customer)) s += customer + '<br>'
        }
      }
      if (this.exportInvoiceTitle && details.hasOwnProperty('CUSTOMER_TITLE')) {
        const customers = details['CUSTOMER_TITLE']
        s += this.$t('CargoMsg.Cargo_Receivable') + this.$t('CargoMsg.Cargo_InvoiceTitleP') + '<br>'
        for (const title of customers) {
          s += title + '<br>'
        }
      }
      if (details.hasOwnProperty('SUPPLIER')) {
        const suppliers = details['SUPPLIER']
        s += this.$t('CargoMsg.Cargo_VendorP') + '<br>'
        let supplier = ''
        for (const supplierId of suppliers) {
          supplier = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', supplierId, 'chineseName')
          if (!StrUtils.isEmpty(supplier)) s += supplier + '<br>'
        }
      }
      if (this.exportInvoiceTitle && details.hasOwnProperty('SUPPLIER_TITLE')) {
        const suppliers = details['SUPPLIER_TITLE']
        s += this.$t('CargoMsg.Cargo_Dues') + this.$t('CargoMsg.Cargo_InvoiceTitleP') + '<br>'
        for (const title of suppliers) {
          s += title + '<br>'
        }
      }
      if (details.hasOwnProperty('DEPARTMENT')) {
        const departments = details['DEPARTMENT']
        s += this.$t('CargoMsg.Cargo_DepartmentP') + '<br>'
        let department = ''
        for (const depId of departments) {
          department = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', depId, 'chineseName')
          if (!StrUtils.isEmpty(department)) s += department + '<br>'
        }
      }
      if (details.hasOwnProperty('SALES')) {
        const sales = details['SALES']
        s += this.$t('CargoMsg.Cargo_SalesP') + '<br>'
        let user = ''
        for (const saleId of sales) {
          user = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', saleId, 'chineseName')
          if (!StrUtils.isEmpty(user)) s += user + '<br>'
        }
      }
      if (details.hasOwnProperty('LOB')) {
        const lobs = details['LOB']
        s += this.$t('CargoMsg.Cargo_BusinessTypeP') + '<br>'
        let state = ''
        for (const lob of lobs) {
          state = ColumnUtils.jobBussStateLabelFunc(lob)
          if (state !== '状态未知' && state !== 'Status unknown') s += state + '<br>'
        }
      }
      // CARGO-44501 根据帐套的passExceptionExport判断添加【全部跳过】
      if (this.accountSet.passExceptionExport) {
        this.$confirm(s + this.$t('CargoMsg.Cargo_CodeNotMaintained'), this.$t('Message.Warning'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_SkipAll'), // 全部跳过的按钮
          cancelButtonText: this.$t('CargoMsg.Cargo_Confirm'), // 添加一个取消按钮的文本
          showCancelButton: true, // 显示取消按钮
          showClose: true,
          closeOnClickModal: false,
          closeOnPressEscape: true,
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          // 去掉根据选择的数据，将有问题的凭证去除后重新再导出，如果去掉后为空就直接停止
          const selections = getGridSelected(this.gridOptions)

          // 取出错误凭证UUID
          if (details.hasOwnProperty('ERROR_DOC_UUID')) {
            const errorDocUuid = details['ERROR_DOC_UUID']
            // 遍历 selections 数组
            const finalSelections = selections.filter(item => {
              // 使用 some 方法检查是否有匹配的 errorProof 项
              return !errorDocUuid.some(errorItem => {
                return item.uuid === errorItem
              })
            })
            // 如果去掉有问题的凭证后 finalSelections 数组为空，则停止执行后续的导出操作
            this.repeatByPassExceptionExport = false
            this.exportHandler(finalSelections)
          }
        }).catch(() => {})
      } else {
        this.$confirm(s + this.$t('CargoMsg.Cargo_CodeNotMaintained'), this.$t('Message.Warning'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: true,
          closeOnClickModal: false,
          closeOnPressEscape: true,
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          //
        }).catch(() => {})
      }
    },
    // 验证必填项
    toCheckDocumentNotNull(accountingKeys) {
      if (accountingKeys.length === 0) return
      const requestBody = { accountingSetKey: this.accountSet.uuid, accountingKeys }
      console.log('requestBody', requestBody)
      this.loading = getLoading()
      checkDocumentNotNull(requestBody).then(res => {
        if (res.data.status === 'SUCCESS') {
          this.$confirm(this.$t('CargoMsg.Cargo_VerifiedSuccessfullyClickToSave'), this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: 'success'
          }).then(() => {
            this.doExport()
          }).catch(() => {})
        } else {
          this.showCheckNotNullResult(res.data.details)
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 验证导出凭证至金蝶精斗云必填项
    toCheckDocumentByJdJDY(accountingKeys) {
      if (accountingKeys.length === 0) return
      const requestBody = { accountingSetKey: this.accountSet.uuid, accountingKeys }
      this.loading = getLoading()
      checkDocumentByJdJDY(requestBody).then(res => {
        if (res.data.status === 'SUCCESS') {
          this.$confirm(this.$t('CargoMsg.Cargo_VerifiedSuccessfullyClickToExport'), this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: 'success'
          }).then(() => {
            this.doExport()
          }).catch(() => {})
        } else {
          this.showCheckNotNullResult(res.data.details)
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    showCheckNotNullResult(details) {
      let s = ''
      for (const key of this.selectedKeys) {
        if (details.hasOwnProperty(key)) {
          const obj = details[key]
          const documentName = obj.documentName
          const documentMessage = obj.documentMessage
          const entryMessageList = obj.entryMessage
          s += this.$t('CargoMsg.Cargo_FVOVNP').format(documentName) + '<br>'
          if (!StrUtils.isEmpty(documentMessage)) s += documentMessage + '<br>'
          if (entryMessageList) {
            for (const m of entryMessageList) {
              s += m + '<br>'
            }
          }
        }
      }
      this.$confirm(s, this.$t('Message.Warning'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        showCancelButton: false,
        showClose: true,
        closeOnClickModal: false,
        closeOnPressEscape: true,
        type: 'warning'
      }).then(() => {
        return
      }).catch(() => {})
    },
    // 开始导出
    async doExport() {
      // CARGO-44501 还原this.repeatByPassExceptionExport
      this.repeatByPassExceptionExport = true

      console.log('doExport')
      if (this.selectedKeys.length === 0) {
        this.$confirm(this.$t('CargoMsg.Cargo_PleaseReselectTheVoucherToExport'), this.$t('Message.Warning'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: true,
          closeOnClickModal: false,
          closeOnPressEscape: true,
          type: 'info'
        }).then(() => {
          return
        }).catch(() => {
        })
        return
      }
      // 亚东 金蝶EAS
      if (this.jdEAS) {
        const obj = {} // 参数
        obj.accountSetKey = this.accountSet.uuid
        obj.voucherKeys = this.selectedKeys.join(',')
        obj.sessionId = this.$store.getters.token
        obj.branchId = this.branchId
        console.log('obj', obj)
        this.loading = getLoading()
        exportExcelByJDEAS(obj).then(res => {
          this.JDEASResultHandler(res.data)
        }).finally(() => {
          this.loading.close()
        })
      } else if (this.jdYXK) {
        // CARGO-26976 【SHA】-导出凭证 ，cargo传导到金蝶数据收入成本，有重复凭证出现
        // const result = await validateVoucherForExportJDYXK(this.selectedKeys).then(res => res.data)
        // if (result && result.hasOwnProperty('hasTargetDocumentNo') && result.hasTargetDocumentNo) {
        //   const flag = await this.$confirm(this.$t('CargoMsg.Cargo_ContinueExportTip'), this.$t('Message.Prompt'), {
        //     confirmButtonText: this.$t('common.btn.ok'),
        //     cancelButtonText: this.$t('common.btn.cancel'),
        //     dangerouslyUseHTMLString: true,
        //     closeOnClickModal: false,
        //     type: 'warning'
        //   }).then(() => true).catch(() => false)
        //   if (!flag) {
        //     return
        //   }
        // }
        let mergeExportUuid = '' // 合并凭证信息取最小凭证号的内容
        if (this.invoicePayableAndReceiptPaymentOffsetMergeExport) {
          const selections = getGridSelected(this.gridOptions)
          for (const doc of selections) {
            if (doc.businessDataType === FinanceInterfaceConstants.INVOICE_PAYABLE.code ||
              doc.businessDataType === FinanceInterfaceConstants.RECEIPT_PAYMENT_OFFSET.code) {
              mergeExportUuid = doc.uuid
            }
          }
        }
        const obj = {} // 参数
        obj.accountSetKey = this.accountSet.uuid
        obj.voucherKeys = this.selectedKeys.join(',')
        obj.sessionId = this.$store.getters.token
        obj.branchId = this.branchId
        obj.mergeExportUuid = mergeExportUuid
        console.log('obj', obj)
        this.loading = getLoading()
        exportExcelByJDYXK(obj).then(res => {
          this.JDEASResultHandler(res.data)
        }).finally(() => {
          this.loading.close()
        })
      } else if (this.directJDEAS) {
        if (this.accountSet.interfaceScheme === 'export-api') { // 导出API
          const obj = {} // 参数
          obj.accountSetKey = this.accountSet.uuid
          obj.voucherKeys = this.selectedKeys.join(',')
          obj.sessionId = this.$store.getters.token
          obj.branchId = this.branchId
          console.log('obj', obj)
          this.loading = getLoading()
          exportExcelByDIRECTJDEAS(obj).then(res => {
            this.DirectJDEASResultHandler(res.data)
          }).finally(() => {
            this.loading.close()
          })
        } else {
          // 导出Excel
          const fileName = 'VH-' + DateUtils.formatStandardDate(new Date()) + '-' + this.voucherNo + '.' + 'xlsx'
          const variables = {}
          variables.accountSetKey = this.accountSet.uuid
          variables.voucherKeys = this.selectedKeys.join(',')
          variables.sessionId = this.$store.getters.token
          variables.branchId = this.branchId
          variables.fileName = fileName
          variables.filePrefix = 'VH-'
          variables.fileType = 'xlsx'
          const serverUrl = `${URL.finance.accountingDocument.voucherExport}?sessionId=${this.$store.getters.token}&fileName=${fileName}`
          await this.navigateToURL(serverUrl, variables)
        }
      } else if (this.jdYXC) {
        const obj = {} // 参数
        obj.anyStr = this.accountSet.uuid
        obj.keys = this.selectedKeys
        obj.branchId = this.branchId
        this.loading = getLoading()
        exportExcelByJDYXC(obj).then(res => {
          this.JDEASResultHandler(res.data)
        }).finally(() => {
          this.loading.close()
        })
      } else if (this.jdJDY) {
        const obj = {} // 参数
        obj.accountSetKey = this.accountSet.uuid
        obj.voucherKeys = this.selectedKeys.join(',')
        obj.sessionId = this.$store.getters.token
        obj.branchId = this.branchId
        this.loading = getLoading()
        exportJdJDY(obj).then(res => {
          this.JDEASResultHandler(res.data)
        }).finally(() => {
          this.loading.close()
        })
      } else if (this.yyTcloud) {
        // const result = await validateVoucherForExportJDYXK(this.selectedKeys).then(res => res.data)
        // if (result && result.hasOwnProperty('hasTargetDocumentNo') && result.hasTargetDocumentNo) {
        //   const flag = await this.$confirm(this.$t('CargoMsg.Cargo_ContinueExportTip'), this.$t('Message.Prompt'), {
        //     confirmButtonText: this.$t('common.btn.ok'),
        //     cancelButtonText: this.$t('common.btn.cancel'),
        //     dangerouslyUseHTMLString: true,
        //     closeOnClickModal: false,
        //     type: 'warning'
        //   }).then(() => true).catch(() => false)
        //   if (!flag) {
        //     return
        //   }
        // }
        const obj = {} // 参数
        obj.accountSetKey = this.accountSet.uuid
        obj.voucherKeys = this.selectedKeys.join(',')
        obj.sessionId = this.$store.getters.token
        obj.branchId = this.branchId
        console.log('obj', obj)
        this.loading = getLoading()
        exportYYTCLOUD(obj).then(res => {
          this.JDEASResultHandler(res.data)
        }).finally(() => {
          this.loading.close()
        })
      } else if (this.yyU8V16) { // 用友U8V16.5
        const obj = {} // 参数
        obj.anyStr = this.accountSet.uuid
        obj.keys = this.selectedKeys
        obj.branchId = this.$store.getters.currentOfficeId
        this.loading = getLoading()
        exportExcelByYYU8V16(obj).then(res => {
          this.JDEASResultHandler(res.data)
        }).finally(() => {
          this.loading.close()
        })
      } else if (this.yyu8) {
        const obj = {} // 参数
        obj.anyStr = this.accountSet.uuid
        obj.keys = this.selectedKeys
        obj.branchId = this.$store.getters.currentOfficeId
        this.loading = getLoading4Cxt()
        exportExcelByYyu8(obj).then(res => {
          this.JDEASResultHandler(res.data)
        }).finally(() => {
          this.loading.close()
        })
      } else if (this.thirdPartyTable) {
        const obj = {} // 参数
        obj.anyStr = this.accountSet.uuid
        obj.keys = this.selectedKeys
        obj.branchId = this.$store.getters.currentOfficeId
        this.loading = getLoading4Cxt()
        exportExcelByOj(obj).then(res => {
          this.JDEASResultHandler(res.data)
        }).finally(() => {
          this.loading.close()
        })
      } else {
        let fileType = 'txt'
        if (this.accountSet.interfaceScheme === 'export-dbf') {
          fileType = 'dbf'
        } else if (this.accountSet.interfaceScheme === 'export-xml') {
          fileType = 'zip'
        } else if (this.accountSet.interfaceScheme === 'export-excel') {
          fileType = 'xls'
        }
        const fileName = 'VH-' + DateUtils.formatStandardDate(new Date()) + '-' + this.voucherNo + '.' + fileType
        const variables = {}
        variables.accountSetKey = this.accountSet.uuid
        variables.voucherKeys = this.selectedKeys.join(',')
        variables.sessionId = this.$store.getters.token
        variables.branchId = this.branchId
        variables.fileName = fileName
        variables.filePrefix = 'VH-'
        variables.fileType = fileType
        const serverUrl = `${URL.finance.accountingDocument.voucherExport}?sessionId=${this.$store.getters.token}&fileName=${fileName}`
        await this.navigateToURL(serverUrl, variables)
      }
    },
    JDEASResultHandler(result) {
      if (result) {
        const status = result.Status
        const message = result.Msg
        const document = result.document
        const successCount = result.successCount
        if (status === 'true') {
          this.$confirm(this.$t('CargoMsg.Cargo_ExportSuccessfully') + successCount + this.$t('CargoMsg.Cargo_Pcst'), this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: 'success'
          }).then(() => {
            this.searchHandler()
          }).catch(() => {})
        } else {
          let str = ''
          if (document) {
            str = '【' + document.prefix + '（' + document.documentNo + '）】'
          }
          this.$confirm(this.$t('CargoMsg.Cargo_SuccessItemsFailedItems').format(successCount, (successCount + 1) + str) + message, this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            dangerouslyUseHTMLString: true,
            type: 'error'
          }).then(() => {
            //
          }).catch(() => {})
        }
      }
    },
    async navigateToURL(URL, PARAMS) {
      const form = document.createElement('form')
      form.action = URL
      form.method = 'post'
      form.style.display = 'none'
      for (const key in PARAMS) {
        const opt = document.createElement('textarea')
        opt.name = key
        opt.value = PARAMS[key]
        form.appendChild(opt)
      }
      form.target = '_blank'
      document.body.appendChild(form)
      form.submit()
    },
    // 红冲凭证
    reverseHandler() {
      console.log('reverseHandler')
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) return
      const accountingKeys = []
      for (const accountingDocument of selections) {
        if (VoucherUtils.checkVoucherDateClosing(accountingDocument.year, accountingDocument.month, this.accountSet.fiscalPeriod)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_VOCMEICSR'))
          return
        }
        if (accountingDocument.state !== FinanceInterfaceConstants.VOUCHER_EXPORTED.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_OEVCBWB'))
          return
        }
        if (!StrUtils.isEmpty(accountingDocument.offsetDocumentUuid) || !StrUtils.isEmpty(accountingDocument.offsetedDocumentUuid)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_WBOWBVCTBWB'))
          return
        }
        accountingKeys.push(accountingDocument.uuid)
      }
      if (accountingKeys.length === 0) return
      this.$confirm(this.$t('CargoMsg.Cargo_STWBTSV').format(selections.length), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        this.reverseVoucher(accountingKeys)
      }).catch(() => {})
    },
    reverseVoucher(accountingKeys) {
      if (accountingKeys.length === 0) return
      const requestBody = { accountingSetKey: this.accountSet.uuid, accountingKeys }
      console.log('requestBody', requestBody)
      this.loading = getLoading()
      reverse(requestBody).then(res => {
        if (res.data) {
          this.$message.success(this.$t('CargoMsg.Cargo_REVERSE'))
        }
        this.searchHandler()
      }).finally(() => {
        this.loading.close()
      })
    },
    onRowClicked(event) {
      this.selectedItem = event.data
      if (event.data && this.accountingEntryWindow.rowData && this.accountingEntryWindow.rowData.length > 0) {
        this.accountingEntryWindow.index = this.accountingEntryWindow.rowData.findIndex(p => p.uuid === event.data.uuid)
      } else {
        this.accountingEntryWindow.index = -1
      }
    },
    onRowDoubleClicked(event) {
      this.selectedItem = event.data
      if (event.data && this.accountingEntryWindow.rowData && this.accountingEntryWindow.rowData.length > 0) {
        this.accountingEntryWindow.index = this.accountingEntryWindow.rowData.findIndex(p => p.uuid === event.data.uuid)
      } else {
        this.accountingEntryWindow.index = -1
      }
      this.$emit('rowDoubleClicked', this.selectedItem)
      //
      this.accountingEntryWindow.visible = false
      this.$nextTick(() => {
        this.accountingEntryWindow.visible = true
      })
    },
    updateTargetDocumentNo(voucher) {
      for (const item of this.rowData) {
        if (item.uuid === voucher.uuid) {
          item.targetDocumentNo = voucher.targetDocumentNo
          item.version = voucher.version
          break
        }
      }
      this.gridOptions.api.refreshCells({ force: true })
    },
    updateAudit(voucher) {
      for (const item of this.rowData) {
        if (item.uuid === voucher.uuid) {
          item.state = voucher.state
          item.verifier = voucher.verifier
          item.verifyDate = voucher.verifyDate
          item.version = voucher.version
          break
        }
      }
      this.gridOptions.api.refreshCells({ force: true })
    },
    DirectJDEASResultHandler(result) {
      if (result) {
        const status = result.Status
        const message = result.Msg
        const document = result.document
        const successCount = result.successCount
        if (status === 'true') {
          this.$message.success(this.$t('CargoMsg.Cargo_AuditSuccessfully'))
          this.searchHandler()
        } else {
          this.$confirm(message, this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            dangerouslyUseHTMLString: true,
            type: 'error'
          }).then(() => {
            //
          }).catch(() => {})
        }
      }
    },
    onSortChanged(event) {
      const rowData = []
      const nodes = event.api.rowModel.rowsToDisplay
      if (nodes && nodes.length > 0) {
        for (const node of nodes) {
          rowData.push(node.data)
        }
      }
      this.accountingEntryWindow.rowData = rowData
      if (this.accountingEntryWindow.index >= 0) {
        event.api.setFocusedCell(this.accountingEntryWindow.index, event.columnApi.getAllDisplayedColumns()[0])
      }
    },
    // 同步用友凭证号
    SyncTargetDocumentNoHandler() {
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseData'))
        return
      }
      this.selectedKeys = []
      for (const doc of selections) {
        if (!StrUtils.isEmpty(doc.targetDocumentNo)) { this.selectedKeys.push(doc.uuid) }
      }
      if (this.selectedKeys.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseTargetDocumentNo'))
        return
      }
      const obj = {} // 参数
      obj.accountSetKey = this.accountSet.uuid
      obj.voucherKeys = this.selectedKeys.join(',')
      obj.sessionId = this.$store.getters.token
      obj.branchId = this.branchId
      this.loading = getLoading()
      queryYYTCLOUD(obj).then(res => {
        if (res.data) {
          if (res.data.Status === 'true') {
            this.searchHandler()
          } else {
            this.$message.error(res.data.Msg)
          }
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 刷新openToken
    RefreshTcloudTokenHandler() {
      this.$confirm(this.$t('CargoMsg.Cargo_ConfirmR') + this.$t('CargoMsg.Cargo_RefreshTcloudToken') + '？', this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        this.RefreshTcloudToken()
      }).catch(() => {
        //
      })
    },
    RefreshTcloudToken() {
      const obj = {} // 参数
      obj.accountSetKey = this.accountSet.uuid
      obj.sessionId = this.$store.getters.token
      obj.branchId = this.branchId
      this.loading = getLoading()
      refreshTcloudToken(obj).then(res => {
        if (res.data) {
          if (res.data.Status === 'true') {
            this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
          } else {
            this.$message.error(res.data.Msg)
          }
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 查询
    async queryAccountTitleName() {
      const requestBody = { accountSetUuid: this.accountSet.uuid }
      console.log('requestBody', requestBody)
      this.loading = getLoading()
      await queryAccountTitle(requestBody).then(res => {
        this.entryAccountTitleDataProvider = res.data.list
      }).finally(() => {
        this.loading.close()
      })
    },
    // 查看导出凭证请求日志
    async queryApiReqLogHandler(data) {
      // const apiReqLog = await queryApiReqLog(data.uuid).then(res => res.data)
      // if (apiReqLog) {}
      // 创建Blob对象
      const blob = new Blob([data.requestMsg], { type: 'text/plain' })
      // 创建下载链接
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      // 设置文件名
      const fileName = data.prefix + '-' + data.documentNo + '.txt'
      link.setAttribute('download', fileName)
      // 触发下载
      document.body.appendChild(link)
      link.click()
      // 清理
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },
    toPreProcessSearchItem(originSearchItems) {
      const searchItem = originSearchItems.find(e => e.itemName === 'accountingDocument.DOCUMENT_DATE' && e.fieldType === 'FIELD_DATE_RANGE')
      if (searchItem && !searchItem.defaultValue) {
        searchItem.defaultValue = [moment().subtract(1, 'months').startOf('month').format('yyyy-MM-DD')]
      }
    }
  }
}
String.prototype.format = function() {
  if (arguments.length == 0) return this
  for (var s = this, i = 0; i < arguments.length; i++) { s = s.replace(new RegExp('\\{' + i + '\\}', 'g'), arguments[i]) }
  return s
}
</script>

<style lang="scss">
.voucher-list {
  .el-form-item {
    margin-right: 10px !important;
    margin-bottom: 4px !important;
    .el-form-item__content {
      .el-input__inner {
        padding: 0px 5px !important;
      }
      .el-date-editor {
        .el-input__prefix {
          display: none;
        }
      }
    }
  }
}
</style>
